export interface VoucherServiceItem {
  icon: string;
  label: string;
  sub: string;
  color: string;
  path: string;
}

interface VoucherServiceSectionProps {
  items: VoucherServiceItem[];
  onNavigate: (path: string) => void;
  className?: string;
}

/**
 * 订单详情「凭证与服务」：电子合同 / 电子发票 / 在线客服等
 * hotel、tour、car 等页面共用。
 */
export default function VoucherServiceSection({
  items,
  onNavigate,
  className = "mx-4 mt-3 bg-white rounded-2xl p-4 mb-4",
}: VoucherServiceSectionProps) {
  return (
    <div className={className}>
      <div className="text-sm font-bold text-gray-900 mb-3">凭证与服务</div>
      <div>
        {items.map((item, idx) => (
          <button
            key={item.label}
            type="button"
            onClick={() => onNavigate(item.path)}
            className="w-full flex items-center justify-between py-3 cursor-pointer active:bg-gray-50 transition-colors"
            style={{ borderTop: idx > 0 ? "1px solid #F8F8F8" : "none" }}
          >
            <div className="flex items-center gap-3">
              <div
                className="w-9 h-9 flex items-center justify-center rounded-xl"
                style={{ background: `${item.color}14` }}
              >
                <i
                  className={item.icon}
                  style={{ color: item.color, fontSize: 17 }}
                />
              </div>
              <div className="text-left">
                <div className="text-sm text-gray-800 font-medium">
                  {item.label}
                </div>
                <div className="text-xs text-gray-400">{item.sub}</div>
              </div>
            </div>
            <i
              className="ri-arrow-right-s-line"
              style={{ color: "#D8DAE0", fontSize: 18 }}
            />
          </button>
        ))}
      </div>
    </div>
  );
}
